import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { Auth } from "aws-amplify";
import axios from "axios";
import {
  CognitoAccessToken,
  CognitoIdToken,
  CognitoRefreshToken,
  CognitoUser,
  CognitoUserPool,
  CognitoUserSession,
} from "amazon-cognito-identity-js";


export default /*#__PURE__*/_defineComponent({
  __name: 'OAuthCallbackView',
  setup(__props) {

const route = useRoute();
const router = useRouter();

onMounted(() => {
  // console.log(route.params);
  // console.log(route.query);

  const type = route.params.type;
  const code = route.query.code?.toString();

  setTimeout(async () => {
    const config = {
      headers: {
        // Authorization: `${user.signInUserSession.idToken.jwtToken}}`,
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };

    const params = new URLSearchParams();
    params.append("grant_type", "authorization_code");
    params.append("client_id", "631iqhir685ama9jfsrpdjcrrg");
    params.append("code", code ?? "");
    params.append("redirect_uri", `http://localhost:8080/oauth/${type}/callback`);

    const response = await axios.post(
      `https://terraspace-prod.auth.ap-northeast-1.amazoncognito.com/oauth2/token`,
      params
      // config
    );

    // console.log(response);

    const idToken = new CognitoIdToken({
      IdToken: response.data.id_token as string,
    });
    const accessToken = new CognitoAccessToken({
      AccessToken: response.data.access_token as string,
    });
    const refreshToken = new CognitoRefreshToken({
      RefreshToken: response.data.refresh_token as string,
    });

    // console.log(accessToken.payload);

    const session = new CognitoUserSession({
      IdToken: idToken,
      AccessToken: accessToken,
      RefreshToken: refreshToken,
    });

    // identityPoolId: process.env.VUE_APP_AWS_COGNITO_IDENTITY_POOL_ID,
    // region: process.env.VUE_APP_AWS_REGION,
    // userPoolId: process.env.VUE_APP_AWS_COGNITO_USER_POOL_ID,
    // userPoolWebClientId: process.env.VUE_APP_AWS_COGNITO_CLIENT_ID,

    const poolData = {
      UserPoolId: process.env.VUE_APP_AWS_COGNITO_USER_POOL_ID!,
      ClientId: process.env.VUE_APP_AWS_COGNITO_CLIENT_ID!,
    };

    const userPool = new CognitoUserPool(poolData);

    const userData = {
      Username: accessToken.payload.username,
      Pool: userPool,
    };

    const cognitoUser = new CognitoUser(userData);

    cognitoUser.setSignInUserSession(session);

    // if (type == "signinwithapple") {
    //   Auth.federatedSignIn("SignInWithApple", {
    //     token: accessToken,
    //     expires_at: expires_at,
    //   });
    // }

    // console.log(session.isValid());

    const info = await Auth.currentUserInfo();
    // console.log(info);

    router.replace("/");
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span"))
}
}

})